import type { ColDef, ColGroupDef } from 'ag-grid-community';
import {
  headerInfoTooltipDef,
  getPureNumber,
  formatPercentage,
  dateFilterParams,
  formatColumnDate,
} from '../lib/utils';

const defaultFilterParams = {
  newRowsAction: 'keep',
};

export default [
  {
    cellClass: 'ticker-cell',
    cellRendererParams: {
      hideOnInitialTicker: true,
    },
    field: 'ticker',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    initialWidth: 90,
    valueGetter: ({ data }) => data.symbol,
    ...headerInfoTooltipDef('Symbol associated with the company'),
  },
  {
    cellClass: 'ticker-cell company-name-cell',
    cellRendererParams: {
      hideOnInitialTicker: true,
    },
    field: 'company',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    headerName: 'Name',
    initialWidth: 160,
    ...headerInfoTooltipDef(''),
  },
  {
    cellClass: 'ticker-cell',
    field: 'recordDate',
    filter: 'agDateColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      ...dateFilterParams,
      buttons: ['clear'],
      inRangeInclusive: true,
    },
    headerName: 'Settlement Date',
    initialSort: 'desc' as ColDef['initialSort'],
    valueFormatter: ({ data }) => formatColumnDate(data.settlementDate),
    valueGetter: ({ data }) => {
      if (!data.settlementDate) return null;

      return data.settlementDate;
    },
  },
  {
    cellClass: 'ticker-cell',
    field: 'recordDate',
    filter: 'agDateColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      ...dateFilterParams,
      buttons: ['clear'],
      inRangeInclusive: true,
    },
    headerName: 'Dissemination Date',
    initialSort: 'desc' as ColDef['initialSort'],
    valueFormatter: ({ data }) => formatColumnDate(data.recordDate),
    valueGetter: ({ data }) => {
      if (!data.recordDate) return null;

      return data.recordDate;
    },
  },
  {
    cellClass: 'ticker-cell company-name-cell',
    field: 'shortPercentOfFloat',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    headerName: '% of Float Shorted',
    initialWidth: 160,
    valueFormatter: ({ value }) => formatPercentage(value),
    ...headerInfoTooltipDef(''),
  },
  {
    cellClass: 'ticker-cell company-name-cell',
    field: 'sharesFloat',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    headerName: 'Float',
    initialWidth: 160,
    valueFormatter: ({ value }) => {
      if (!value) return '-';

      return Number(value).toLocaleString('en');
    },
    valueGetter: ({ data }) => getPureNumber(data.sharesFloat),
    ...headerInfoTooltipDef(''),
  },
  {
    cellClass: 'ticker-cell company-name-cell',
    field: 'totalShortInterest',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    headerName: 'Short Interest',
    initialWidth: 160,
    valueFormatter: ({ value }) => {
      if (!value) return '-';

      return Number(value).toLocaleString('en');
    },
    ...headerInfoTooltipDef(''),
  },
  {
    cellClass: 'ticker-cell company-name-cell',
    field: 'averageDailyVolume',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    headerName: 'Volume',
    initialWidth: 160,
    valueFormatter: ({ value }) => {
      if (!value) return '-';

      return Number(value).toLocaleString('en');
    },
    ...headerInfoTooltipDef(''),
  },
  {
    cellClass: 'ticker-cell company-name-cell',
    field: 'daysToCover',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    headerName: 'Days to Cover',
    initialWidth: 160,
    ...headerInfoTooltipDef(''),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: () => {
      return (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a href="https://www.benzinga.com/profile/portfolio/?action=login&utm_source=calendars" target="_blank">
          Get Alert
        </a>
      );
    },
    cellRendererParams: {
      hideOnInitialTicker: true,
    },
    field: 'get_alert',
    headerName: 'Get Alert',
    initialWidth: 70,
    suppressAutoSize: true,
    suppressHeaderMenuButton: true,
    suppressSizeToFit: true,
  },
] as (ColDef | ColGroupDef)[];
